<script>
    import { onMount, createEventDispatcher } from "svelte";
    import { Grid, GridItem } from "../../index";
    const dispatch = createEventDispatcher();
    let cls = "sui-selector";
    export let options = [];
    export let columns = 3;
    export let gap = 8;
    export let multiple = false;
    export let disabled = false;
    export let defaultValue = [];
    export let showCheckMark = true;
    onMount(() => {
        if (defaultValue.length > 0 && options.length > 0) {
            options = options.map((el) => {
                if (defaultValue.includes(el.value)) {
                    el.active = !el.active;
                }
                return el;
            });
        }
    });

    function handleClick(i) {
        if (options[i].disabled || disabled) return;
        options = options.map((el, index) => {
            if (i === index) {
                el.active = !el.active;
            } else if (!multiple) {
                el.active = false;
            }
            return el;
        });

        setTimeout(emit, 50);
    }

    function emit() {
        let arr = [];
        let newOpt = options.filter((el) => {
            if (el.active) {
                arr.push(el.value);
                return el;
            }
        });
        dispatch("change", { arr, items: newOpt });
    }
</script>

{#if options.length > 0}
    <div class={cls} class:disabled>
        <Grid {columns} {gap}>
            {#each options as option, i}
                <GridItem>
                    <div
                        class={`${cls}-item`}
                        class:active={option.active}
                        class:disabled={option.disabled}
                        role="button"
                        on:click={() => handleClick(i)}
                    >
                        {option.label}
                        {#if showCheckMark}
                            <b class={`${cls}-item-mark`} />
                        {/if}
                    </div>
                </GridItem>
            {/each}
        </Grid>
    </div>
{/if}

<style lang="less">
    @import "./selector.less";
</style>
